import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { showAppShellError, watchAppShell } from './app/core/startup/app-shell';

// Configure PDF.js worker for ng2-pdf-viewer
// Using .js extension for better server compatibility (.mjs requires specific MIME type config)
(window as any).pdfWorkerSrc = '/assets/pdfjs/pdf.worker.min.js';
(window as any)['pdfWorkerSrc4.8.69'] = '/assets/pdfjs/pdf.worker.min.js';

watchAppShell(document);
bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  showAppShellError(document);
});
